import { Dispatch } from "../types/types";
import { request } from "../helpers/httpInterceptor";
import h from "../helpers";
import { ILogMessage } from "../types/stores/logMessage";
import { GET_LOG_MESSAGES } from "../reducers/logMessage";

const renderNullValues = (row: ILogMessage) => {
    if (row.log_sysdate == null) {
        row.log_sysdate = "NA";
    }

    if (row.log_level == null) {
        row.log_level = "NA";
    }

    if (row.log_logger == null) {
        row.log_logger = "NA";
    }

    if (row.log_class == null) {
        row.log_class = "NA";
    }

    if (row.log_method == null) {
        row.log_method = "NA";
    }

    if (row.log_username == null) {
        row.log_username = "NA";
    }

    if (row.log_message == null) {
        row.log_message = "NA";
    }

    if (row.log_exception == null) {
        row.log_exception = "NA";
    }

    if (row.log_stacktrace == null) {
        row.log_stacktrace = "NA";
    }

    if (row.log_stacktracedetail == null) {
        row.log_stacktracedetail = "NA";
    }

    if (row.appfree1 == null) {
        row.appfree1 = "NA";
    }

    if (row.appfree2 == null) {
        row.appfree2 = "NA";
    }

    if (row.appfree3 == null) {
        row.appfree3 = "NA";
    }

    return row;
};

export const GetLogMessages =
    (startDate: string, endDate: string) =>
    (dispatch: Dispatch): Promise<Response> => {
        dispatch({ type: GET_LOG_MESSAGES, logMessages: [], isLoading: true });
        return request(
            `/api/LogMessage/GetLogMessages?startDate=${startDate}&endDate=${endDate}`,
            {
                credentials: "same-origin",
                method: "GET",
            },
            dispatch
        )
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as Array<ILogMessage>;
                const logMessages: Array<ILogMessage> = response.map(x => renderNullValues(x));

                dispatch({
                    type: GET_LOG_MESSAGES,
                    logMessages,
                    isLoading: false,
                });
            })
            .catch(error => {
                dispatch({
                    type: GET_LOG_MESSAGES,
                    logMessages: [],
                    isLoading: false,
                });
                h.error("Error loading Log Messages.", error);
            });
    };
